module.exports = __webpack_public_path__ + "static/AppIconList-ae999d727826d8ec418f7ca74e35fb77.png";